import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Exercise } from "../../../../models/Exercise";
import { SaleStep } from "../../../../store/stepSaleConfig/stepSaleConfigReducer";
import useEvents from "../../../EventSale/hooks/useEvents";
import EAProductBanner from "../../../shared/ProductBanner/EAProductBanner";
import { replaceVariablesInString } from "../../OfferModules/replaceVariablesInString";
import useFacility from "../../../../../utils/hooks/useFacility";
import RecruitmentConfirmModal from "../RecruitmentConfirmModal";

interface IProps {
  item: Exercise;
  saleStep: SaleStep;
  highlightedFeatures?: string[];
}

const SingleRecruitment: React.FC<IProps> = ({ item, saleStep, highlightedFeatures }) => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const { getTicketsForEvent, tickets, formatTicketAccess } = useEvents();
  const [ticketsLoaded, setTicketsLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const loadTickets = async () => {
      await formatTicketAccess(item);
      await getTicketsForEvent(item.exerciseGroup.objectDb, item.exerciseGroup.objectId);
      setTicketsLoaded(true);
    };
    loadTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.objectId]);

  const hasTickets = tickets.length > 0;
  const isSoldOut = item.capacity - item.reserved <= 0;
  const hasNoTickets = ticketsLoaded && !hasTickets;
  const isUnavailable = isSoldOut || hasNoTickets;
  const buttonTitle = saleStep.buttonCustomTitle || t("zloz_rezerwacje");

  const getButtonCaption = () => {
    if (isSoldOut) {
      return t("wszystkie_bilety_zostaly_sprzedane");
    }
    if (hasNoTickets) {
      return t("brak_dostepnych_biletow");
    }
    return undefined;
  };

  return (
    <>
      <EAProductBanner
        title={item.name}
        pictureUrl={item.eventMessage}
        description={item.description}
        mainPrice=""
        buttonTitle={buttonTitle}
        onClick={() => setIsModalOpen(true)}
        highlightBanner={saleStep.highlightBanner}
        bannerLabel={replaceVariablesInString(saleStep.bannerLabel ? saleStep.bannerLabel : "", item)}
        highlightedFeatures={highlightedFeatures}
        loginRequired={saleStep.loginRequired}
        hidePrice
        buttonDisabled={isUnavailable}
        buttonCaption={getButtonCaption()}
      />

      {isModalOpen && hasTickets && !isSoldOut && (
        <RecruitmentConfirmModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          item={item}
          tickets={tickets}
          saleStep={saleStep}
          facilityIds={facilityIds}
        />
      )}
    </>
  );
};

export default SingleRecruitment;
